let { protocol, host } = window.location;
let pathname = "";

export const baseUrl = `${protocol}//${host}${pathname}`;
